import { Helmet } from 'react-helmet-async'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/auth-context'

export const Unauthorized = () => {
  const { user } = useAuth()
  const location = useLocation()
  const from = location.state?.from

  return (
    <div className='container mx-auto flex flex-col items-center justify-center min-h-[60vh] px-6 py-12'>
      <Helmet>
        <title>دسترسی محدود - بوک استوری</title>
        <meta
          name='description'
          content='دسترسی به این صفحه نیاز به احراز هویت دارد'
        />
      </Helmet>

      <div className='text-center max-w-md'>
        {/* 403 Icon */}
        <div className='mb-8'>
          <svg
            className='w-32 h-32 mx-auto text-red-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
            />
          </svg>
        </div>

        {/* Error Code */}
        <h1 className='text-6xl font-bold text-gray-800 dark:text-gray-200 mb-4'>
          403
        </h1>

        {/* Error Message */}
        <h2 className='text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-4'>
          دسترسی محدود
        </h2>

        <p className='text-gray-600 dark:text-gray-400 mb-8 leading-relaxed'>
          {!user ? (
            <>
              برای دسترسی به این بخش نیاز به ورود به حساب کاربری دارید.
              <br />
              لطفاً ابتدا وارد حساب خود شوید.
            </>
          ) : (
            <>
              متأسفانه شما مجوز دسترسی به این صفحه را ندارید.
              <br />
              در صورت نیاز با پشتیبانی تماس بگیرید.
            </>
          )}
        </p>

        {/* Action Buttons */}
        <div className='flex flex-col sm:flex-row gap-4 justify-center'>
          {!user ? (
            <Link
              to='/login'
              state={{ from }}
              className='px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium'
            >
              ورود به حساب کاربری
            </Link>
          ) : (
            <Link
              to='/'
              className='px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium'
            >
              بازگشت به صفحه اصلی
            </Link>
          )}

          <Link
            to='/'
            className='px-6 py-3 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200 font-medium'
          >
            صفحه اصلی
          </Link>
        </div>

        {/* Support Link */}
        <div className='mt-8'>
          <Link
            to='/contact-us'
            className='text-blue-600 dark:text-blue-400 hover:underline'
          >
            تماس با پشتیبانی
          </Link>
        </div>
      </div>
    </div>
  )
}
